import { unref as _unref, isRef as _isRef, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "radio-group-container" }
const _hoisted_2 = { class: "grid md:grid-cols-2 gap-2 lg:gap-8 w-full" }
const _hoisted_3 = { class: "flex items-center md:items-start" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "checkmark" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "ml-6" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "h4 md:mb-1 text-mobile-title-tile" }, "Chcę wybrać Iek"),
  /*#__PURE__*/_createElementVNode("p", { class: "hidden md:block text-[14px] leading-[21px] lg:text-base" }, " W przypadku braku przeciwwskazań, nasi Iekarze wystawią receptę na wskazany przez Ciebie Iek. ")
], -1)
const _hoisted_6 = { class: "flex items-center md:items-start" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "checkmark" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "ml-6" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "h4 md:mb-1 text-mobile-title-tile" }, "Niech zdecyduje Iekarz"),
  /*#__PURE__*/_createElementVNode("p", { class: "hidden md:block text-[14px] leading-[21px] lg:text-base lg:leading-[26px]" }, " Nasz Iekarz zdecyduje o metodzie leczenia i odpowiednim Ieku podczas konsultacji. ")
], -1)
const _hoisted_9 = {
  key: 0,
  class: "error-message"
}

import { useField } from 'vee-validate';


export default {
  __name: 'PrescriptionChoice',
  setup(__props) {

const { value, errorMessage } = useField('receiptPlan');

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", {
        class: _normalizeClass(["radio-button form-radio-button p-6 lg:p-[48px] rounded-3xl border-[1px] border-greyScale100", {
                    'bg-white shadow-tile': _unref(value) === 'own',
                }])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            name: "receiptPlan",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (_isRef(value) ? (value).value = $event : null)),
            type: "radio",
            value: "own"
          }, null, 512), [
            [_vModelRadio, _unref(value)]
          ]),
          _hoisted_4,
          _hoisted_5
        ])
      ], 2),
      _createElementVNode("label", {
        class: _normalizeClass(["radio-button form-radio-button p-6 lg:p-[48px] rounded-3xl border-[1px] border-greyScale100", {
                    'bg-white shadow-tile': _unref(value) === 'doctor',
                }])
      }, [
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            name: "receiptPlan",
            type: "radio",
            value: "doctor",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_isRef(value) ? (value).value = $event : null))
          }, null, 512), [
            [_vModelRadio, _unref(value)]
          ]),
          _hoisted_7,
          _hoisted_8
        ])
      ], 2)
    ]),
    (_unref(errorMessage))
      ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_unref(errorMessage)), 1))
      : _createCommentVNode("", true)
  ]))
}
}

}